module.exports = __webpack_public_path__ + "img/about-ceo.012472cc.png";